import { RouteType } from "types/RouteType";
import productionDashboardRoute from "./Dashboard/ProductionDashboard.Route";
import productionScheduleCalendarRoute from "./ProductionScheduleCalendar/ProductionScheduleCalendar.Route";
import castingMapRoute from "./CastingMap/castingMap.Route";
// import dailyCompressionRoute from "./DailyCompression/dailyCompression.Route";
import fabricationSequenceRoute from "./FabricationSequence/fabricationSequence.Route";
// import finishingReportRoute from "./FinishingReport/finishingReport.Route";
import productionMonitorRoute from "./ProductionMonitor/productionMonitor.Route";
import productionReportRoute from "./ProductionReport/productionReport.Route";
import panelPlantTrackerRoute from "./PanelPlantTracker/PanelPlantTracker.Route";
import moldEngineerAssignmentRoute from "./MoldEngineerAssignment/MoldEngineerAssignment.Route";
import holdManagementRoute from "./HoldManagement/HoldManagement.Route";
import bomRoute from "../bom/BOM.Route";
import manholeRoute from "./manhole/Manhole.Route";
import trailerLoadBuilderRoute from "./trailer-load-builder/TrailerLoadBuilder.Route";
import productionScheduleUploadRoute from "./ProductionScheduleUpload/ProductionScheduleUpload.Route";
import masterPieceListRoute from "./MasterPieceList/MasterPieceList.Route";
import laborEfficiencyReportRoute from "./LaborEfficiencyReport/LaborEfficiencyReport.Route";
import productionOutlookRoute from "./ProductionOutlook/ProductionOutlook.Route";
import qrScannerRoute from "./QRScanner/QRScanner.Route";

const productionRoutesList: RouteType[] = [
  // =========================================================================
  // ACTIVE ROUTES - Currently in use
  // =========================================================================
  productionDashboardRoute, // Add dashboard first for navigation priority
  productionScheduleCalendarRoute, // Theory of Constraints production scheduling
  ...castingMapRoute,
  ...fabricationSequenceRoute,
  ...productionMonitorRoute,
  ...productionReportRoute,
  panelPlantTrackerRoute,
  moldEngineerAssignmentRoute,
  bomRoute,
  manholeRoute,
  trailerLoadBuilderRoute,
  productionScheduleUploadRoute,
  masterPieceListRoute,
  laborEfficiencyReportRoute,
  productionOutlookRoute,
  qrScannerRoute,

  // =========================================================================
  // HIDDEN ROUTES - Not currently in use but available for future use
  // To re-enable: uncomment the route below and it will appear in navigation
  // =========================================================================
  // dailyCompressionRoute,    // Daily compression tracking
  // ...finishingReportRoute,  // Finishing report
  // holdManagementRoute,      // Hold management interface
];

export default productionRoutesList;
